const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;

declare global {
  interface Window {
    grecaptcha?: {
      ready: (cb: () => void) => void;
      execute: (key: string, options: { action: string }) => Promise<string>;
    };
  }
}

const loadScript = () =>
  new Promise<void>((resolve, reject) => {
    if (!SITE_KEY) {
      resolve();
      return;
    }
    if (window.grecaptcha) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load reCAPTCHA"));
    document.head.appendChild(script);
  });

export const getRecaptchaToken = async (
  action: string
): Promise<string | undefined> => {
  if (!SITE_KEY) {
    return undefined;
  }
  await loadScript();
  if (!window.grecaptcha) {
    return undefined;
  }
  return new Promise((resolve) => {
    window.grecaptcha?.ready(async () => {
      const token = await window.grecaptcha?.execute(SITE_KEY, { action });
      resolve(token);
    });
  });
};
